import { Autocomplete, Box, TextField } from '@mui/material';
import { Language } from '@shared/domain/language/language.aggregate';
import { languageRepository } from '@shared/domain/language/language.repository';
import {
  languageCodeSelector,
  setLanguageCodeAction
} from '@shared/infrastructure/state/global.slice';
import {
  useAppDispatch,
  useAppSelector
} from '@shared/infrastructure/state/store';
import { useEffect, useState } from 'react';

export const LanguageSelector = () => {
  const dispatch = useAppDispatch();
  const languageCode = useAppSelector(languageCodeSelector);
  const [language, setLanguage] = useState<Language>();
  const [languages, setLanguages] = useState<Language[]>([]);

  useEffect(() => {
    languageRepository.getLanguages().then((languages) => {
      setLanguages(languages || []);
      setLanguage(languages.find((l) => l.code === languageCode));
    });
  }, []);

  const handleChange = (event: any, value: Language) => {
    dispatch(setLanguageCodeAction(value.code as string));
    setLanguage(languages.find((l) => l.code === value.code));
  };

  return (
    <Box sx={{ minWidth: 160 }}>
      <Autocomplete
        key={language ? language.code : 'none'}
        disableClearable
        color='secondary'
        options={languages}
        getOptionLabel={(language) => language.name}
        isOptionEqualToValue={(option, value) => option.code === value.code}
        renderInput={(params) => (
          <TextField color='secondary' {...params} label='Language' />
        )}
        value={language}
        onChange={handleChange}
        size='small'
        sx={{
          color: 'white',
          minWidth: 160,
          '& .MuiAutocomplete-popupIndicatorOpen': {
            color: 'white'
          },
          '& .MuiInputBase-input[aria-expanded="true"]': {
            color: 'white'
          }
        }}
      />
    </Box>
  );
};
